export const API_PATH: string = process.env.REACT_API_URL || "https://newsletter-ayyildiz-ai-hu62knthqa-ew.a.run.app";
